// extracted by mini-css-extract-plugin
export default {"sliderWrapper":"upcomingLiveGameBannner_sliderWrapper__rALa9"};